import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    }
});
export default stylesheet;
